module.exports = __webpack_public_path__ + "img/img-27.7f2471c3.png";